import {styled} from "src/core/styledComponents";

export const InputFile = styled.input`
    position: absolute;
    top: 0;
    visibility: hidden;
`;
